import axios from 'axios';
export default axios.create({
    baseURL: 'https://k1380kvks2.execute-api.ap-south-1.amazonaws.com/latest/',
});